var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_9297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5103 0L21.0332 12.1918L24.0973 5.00685L37.5103 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.929356 0.0141602L14.3065 5.00751L17.2159 12.2867L0.929356 0.0141602ZM30.8797 25.9285L38.1624 26.0671L35.6172 34.7134L26.7307 32.2667L30.8797 25.9285ZM7.52156 25.9285L11.6551 32.2667L2.78366 34.7135L0.253906 26.0671L7.52156 25.9285Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.819 10.4329L17.1166 20.0454L8.21094 19.6402L10.7441 15.8185L10.7762 15.7818L16.819 10.4329ZM21.4874 10.3257L27.6224 15.7821L27.6542 15.8187L30.1874 19.6404L21.2837 20.0454L21.4874 10.3257ZM11.9146 25.9567L16.7773 29.7456L11.1286 32.4727L11.9146 25.9567ZM26.485 25.9561L27.2546 32.4729L21.6217 29.7453L26.485 25.9561Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7469 29.3882L27.463 32.156L22.1459 34.6829L22.2011 33.0128L21.7469 29.3882ZM16.6519 29.3894L16.2155 32.9855L16.2514 34.6809L10.9219 32.156L16.6519 29.3894Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0019 21.2998L16.4956 24.439L11.4102 22.9492L15.0019 21.2998ZM23.3997 21.3001L27.0084 22.9492L21.9063 24.4386L23.3997 21.3001Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3041 25.9243L11.4821 32.6803L7.07617 26.072L12.3041 25.9243ZM26.0966 25.9244L31.3247 26.072L26.9023 32.6806L26.0966 25.9244ZM30.317 19.2578L26.5123 23.1355L23.5787 21.7949L22.1743 24.7475L21.2536 19.6702L30.317 19.2578ZM8.08147 19.2578L17.1467 19.6702L16.2259 24.7475L14.8211 21.7954L11.9032 23.1356L8.08147 19.2578Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82422 18.4624L12.1289 22.8305L12.278 27.1429L7.82422 18.4624ZM30.5788 18.4546L26.1169 27.1505L26.2849 22.8305L30.5788 18.4546ZM16.9354 18.7285L17.1086 19.819L17.5367 22.5356L17.2615 30.8794L15.9602 24.1766L15.9598 24.1073L16.9354 18.7285ZM21.461 18.7133L22.4392 24.1073L22.4387 24.1766L21.1342 30.8962L21.0826 29.2154L20.879 22.4861L21.461 18.7133Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6687 22.6567L26.523 26.4034L21.9819 29.9415L21.0639 29.2929L22.0929 23.9926L26.6687 22.6567ZM11.748 22.6567L16.3079 23.9926L17.3369 29.2929L16.4189 29.9415L11.8776 26.4031L11.748 22.6567Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0527 31.3286L15.8625 34.0814L15.8379 32.9059L16.3241 32.4791H22.0742L22.5779 32.9044L22.5407 34.079L28.3137 31.3355L25.5045 33.6569L22.1078 35.9899H16.2774L12.8829 33.6473L10.0527 31.3286Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3299 29.022L22.1513 29.6023L22.6327 33.4429L21.936 32.8548H16.4646L15.7812 33.4548L16.2469 29.6026L17.0686 29.022H21.3299Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4221 0.337402L38.4 6.27095L37.1648 12.2705L38.0443 12.949L36.8541 13.8571L37.7487 14.548L36.5642 15.6266L37.2914 16.1533L35.3615 18.4072L27.446 16.1024L27.3774 16.0657L21.6734 11.254L36.4221 0.337402ZM1.9779 0.337402L16.7268 11.254L11.0226 16.0657L10.9541 16.1024L3.03855 18.4072L1.10865 16.1533L1.83525 15.6271L0.65145 14.548L1.54425 13.8578L0.33615 12.9472L1.2489 12.2683L0 6.27125L1.9779 0.337402Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0583 15.5985L35.4452 18.0403L38.17 26.4382H30.9814L26.0284 26.5006L29.6305 19.4794L27.0583 15.5985ZM11.3407 15.5985L8.76804 19.4794L12.3706 26.5006L7.41984 26.4382H0.244141L2.95359 18.0405L11.3407 15.5985ZM24.5071 4.9668L22.1612 11.3026L21.6634 19.8616L21.4729 22.5444L21.4577 29.3976H16.9411L16.9264 22.5573L16.7353 19.8594L16.2373 11.3026L13.8917 4.9668H24.5071Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_9297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.3f6d0179fcaa6c8dad019a8ba470e32f.svg";
export { ForwardRef as ReactComponent };